import type { AeropayBankConnection } from '@iheartjane/data-access';
import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import type { ActionResult } from '@jane/bloom/types/actions/remixAction';

export function useAeropayBankConnection() {
  const basename = useBloomBasename();
  const fetcher = useFetcher<ActionResult<AeropayBankConnection>>();

  const fetchBankConnection = useCallback(() => {
    fetcher.load(`${basename}api/bank-connection`);
  }, [basename, fetcher]);

  return {
    data: fetcher.data,
    fetchBankConnection,
    state: fetcher.state,
  };
}
